/* eslint-disable jsx-a11y/label-has-associated-control */
/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { formatCurrencyWithoutCurrency, keyEmptyCheck } from 'aurora-utils/utils';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import classNames from 'classnames';

import { ADGMImage, ADGMAlert, ADGMPanel } from 'aurora-components';

const PaymentMethod = ({
  classes,
  balance,
  lowBalance,
  cardActive,
  walletActive,
  walletHandler,
  creditCardHandler,
  disableWallet,
  disableWalletMessage,
  hideWallet,
}) => {
  return (
    <ADGMPanel title={keyEmptyCheck('pay_with')} hasBodyBorder>
      <>
        {lowBalance ? (
          <div className={classes.adgmwalletDetail}>
            <div className={classes.warningmassage}>
              <ADGMImage name='Information.svg' alt='InformationIcon' />
              <Typography variant='body1'>{keyEmptyCheck('wallet_empty_message')}</Typography>
            </div>
          </div>
        ) : null}
        <FormControl component='fieldset' className={classes.paymentMethodFormControl}>
          <RadioGroup className={classes.paymentMethodRadioGroup}>
            <Radio
              className={classes.paymentMethodRadioBtn}
              value='card'
              name='radio-button-demo'
              inputProps={{ 'aria-label': 'A' }}
              id='userRadioA'
              checked={cardActive}
              onClick={creditCardHandler}
            />
            <label htmlFor='userRadioA' className={classes.paymentMethodRadioLabel}>
              <span className={classes.paymentMethodRadioTitleWithIcon}>{keyEmptyCheck('debit_credit_card')}</span>
            </label>
          </RadioGroup>
          {hideWallet && (
            <RadioGroup className={classes.paymentMethodRadioGroup}>
              <Radio
                className={classes.paymentMethodRadioBtn}
                value='wallet'
                name='radio-button-demo'
                inputProps={{ 'aria-label': 'b' }}
                id='userRadiob'
                checked={walletActive}
                onClick={walletHandler}
                disabled={lowBalance || disableWallet}
              />
              <label
                htmlFor='userRadiob'
                className={classNames(classes.paymentMethodRadioLabel, {
                  [classes.paymentMethodRadioLabelDisabled]: lowBalance || disableWallet,
                })}
              >
                <span className={classes.paymentMethodRadioTitleWithIcon}>
                  {/* <ADGMImage name='ADGMwallet.svg' alt='ADGMwallet' /> */}
                  {keyEmptyCheck('adgm_wallet')}
                </span>
                <span className={classes.paymentMethodRadioAmount}>
                  <span>{keyEmptyCheck('balance')}: </span>
                  {keyEmptyCheck('AED_amount', { num: formatCurrencyWithoutCurrency(balance) })}
                </span>
              </label>
              {disableWalletMessage && (
                <ADGMAlert
                  visible
                  noBackground
                  type='info'
                  customClasses={{ container: classes.disableWalletMessageContainer }}
                >
                  {keyEmptyCheck(disableWalletMessage)}
                </ADGMAlert>
              )}
            </RadioGroup>
          )}
        </FormControl>
      </>
    </ADGMPanel>
  );
};

PaymentMethod.propTypes = {
  classes: PropTypes.object.isRequired,
  balance: PropTypes.number.isRequired,
  lowBalance: PropTypes.bool.isRequired,
  cardActive: PropTypes.bool.isRequired,
  walletActive: PropTypes.bool.isRequired,
  disableWallet: PropTypes.bool.isRequired,
  disableWalletMessage: PropTypes.string.isRequired,
  walletHandler: PropTypes.func.isRequired,
  creditCardHandler: PropTypes.func.isRequired,
  hideWallet: PropTypes.bool.isRequired,
};

export default PaymentMethod;
